import './GooglePreview.css';

export const GooglePreview = ({ desktop, mobile }) => {
  const hasDesktop = desktop?.url || desktop?.title || desktop?.description;
  const hasMobile = mobile?.url || mobile?.title || mobile?.description;

  return (
    <div className="google-preview">
      {/* Desktop Version */}
      {hasDesktop && (
      <div className="google-preview__section">
        <h3 className="google-preview__label">Desktop Version</h3>
        <div className="google-preview__desktop">
            <p className="google-preview__url">{desktop?.url || ''}</p>
            <p className="google-preview__title google-preview__title--desktop">{desktop?.title || ''}</p>
            <p className="google-preview__description google-preview__description--desktop">{desktop?.description || ''}</p>
          </div>
        </div>
      )}

      {/* Mobile Version */}
      {hasMobile && (
      <div className="google-preview__section">
        <h3 className="google-preview__label">Mobile Version</h3>
        <div className="google-preview__mobile">
            <p className="google-preview__url google-preview__url--mobile">{mobile?.url || ''}</p>
            <p className="google-preview__title google-preview__title--mobile">{mobile?.title || ''}</p>
            <p className="google-preview__description google-preview__description--mobile">{mobile?.description || ''}</p>
          </div>
        </div>
      )}
    </div>
  );
};
